import type { TThunkAction } from 'shared/types/redux';

import {
  changeModalType,
  setCpdDraftSource,
  setCpdDraftStatus,
  setCpdPickLandingChannel,
  setCPDChatIdLoadingStatus,
  setCpdDealType,
} from './actions';
import { ECPDDraftStatus } from 'shared/types/redux/cpd';

export const closeCPDModal = (): TThunkAction<void> => dispatch => {
  dispatch(changeModalType(null));
  dispatch(setCpdPickLandingChannel(null));
  dispatch(setCpdDraftSource(null));
  dispatch(setCpdDraftStatus(ECPDDraftStatus.Init));
  dispatch(setCPDChatIdLoadingStatus(null));
  dispatch(setCpdDealType(null));
};
